export default "__VITE_ASSET__bd214d42__"